export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/drone_videography.a8f46e8.svg";